export default "__VITE_PUBLIC_ASSET__7b960b6a__"